<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
        <path
            d="M19.8361 4.20871L13.6156 10.6837L19.8361 17.1584C20.7613 18.1218 20.7613 19.6824 19.8361 20.6458C19.3737 21.127 18.7676 21.3678 18.1618 21.3678C17.555 21.3678 16.9488 21.1274 16.4869 20.6458L10.265 14.1704L4.04368 20.6458C3.58143 21.1269 2.97525 21.3677 2.3689 21.3677C1.76273 21.3677 1.15696 21.1273 0.694302 20.6458C-0.230962 19.6828 -0.230962 18.1222 0.694302 17.1584L6.91459 10.6837L0.693948 4.20871C-0.231316 3.24569 -0.231316 1.68475 0.693948 0.721718C1.61904 -0.240573 3.11788 -0.240573 4.04332 0.721718L10.265 7.19674L16.4861 0.721718C17.4118 -0.240573 18.9108 -0.240573 19.8357 0.721718C20.7613 1.68475 20.7613 3.24569 19.8361 4.20871Z"
            :fill="color" />
    </svg>
</template>

<script setup>

const props = defineProps({
  color: {
    type: String,
    default: "black",
  },
});

const color = props.color;
</script>